import { Modal, ModalBody, ModalHeader } from "reactstrap";
import React from "react";
import cargando from "../../assets/img/cargando.gif";

export const ModalEspere = ({ open }) => {
    return (
        <Modal centered={true} isOpen={open}>
            <ModalHeader>
                <div>
                    <h4>Procesando</h4>
                </div>
            </ModalHeader>
            <ModalBody className={"pb-2"}>
                <div>
                    <img src={cargando} alt={"cargando..."} />
                    <h5>Estamos cargando su información...</h5>
                </div>
            </ModalBody>
        </Modal>
    );
};
